// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {
  padding: 32px;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {
  padding: 14px 20px;
  align-items: center;
  justify-content: flex-end;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {
  width: 50px;
  max-height: 28px;
  min-height: unset;
  padding: 10px 6px;
  border-radius: 8px;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar > div {
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 22px;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {
  font-size: 12px;
  font-weight: 500;
}

.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {
  display: none;
}

.BC-Onboarding-Plan-Modal h1 {
  font-weight: 700;
  font-size: 28px;
  text-align: center;
  margin-bottom: 8px;
  line-height: 36px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {
  text-align: center;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {
  max-width: 1172px;
  margin: auto;
  margin-top: 24px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {
  font-size: 12px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,
.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .BC-Page__SubscriptionV3.V4
  .price
  > .price-number {
  font-size: 36px !important;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {
  background-color: #f6f6f7;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button {
  background-color: transparent;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button__Text {
  display: flex;
  gap: 4px;
  align-items: center;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare
  .Polaris-Button
  .Polaris-Icon {
  margin: 0;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .compare-action
  .btn-compare.btn-compare--expand
  .Polaris-Icon {
  transform: rotate(180deg);
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {
  margin-bottom: 48px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {
  width: 100%;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 8px;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {
  text-align: center;
}

.BC-Onboarding-Plan-Modal
  .BC-Onboarding-Plan-Modal__Content
  .column-package--success
  .Polaris-Button {
  background: #008060;
  border-color: #008060;
  color: #ffffff;
}

.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {
  overflow: auto;
  max-height: 500px;
}

.BC-Onboarding-Plan-Modal .btn-to-top {
  position: fixed;
  bottom: 80px;
  right: 28px;
  z-index: 99;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #007f5f;
  cursor: pointer;
  transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {
  width: 18px;
  height: 18px;
}

.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {
  fill: #007f5f;
}

.BC-Onboarding-Plan-Modal .btn-to-top:hover {
  background-color: #fff;
}
.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content {
  padding: 24px;
}

.BC-Onboarding-PlanV5-Modal h1 {
  margin-bottom: 12px;
}

.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .Polaris-Card {
  max-width: 936px;
  margin: auto;
  margin-top: 24px;
}

.BC-Onboarding-PlanV5-Modal .BC-SubscriptionV5_ExplorePackages .packages {
  margin-top: unset !important;
}

.BC-Onboarding-PlanV5-Modal .BC-Page__Package-ComparisonV5 {
  max-width: 1172px;
  margin: auto;
  height: auto;
  margin-top: 60px;
}

.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {
  max-height: unset;
}

.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .info {
  padding: 31px 20px 16px !important;
}
.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .price {
  line-height: 40px !important;
  font-size: 26px !important;
  justify-content: start !important;
  margin-top: 11px !important;
}

.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .price-number {
  line-height: 48px !important;
  font-size: 38px !important;
}

.BC-SubscriptionV5_ExplorePackages .package-card .price .onboarding-month-text p {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}

.BC-SubscriptionV5_ExplorePackages .package-card .price .onboarding-month-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  margin-left: 8px;
}

.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .Polaris-Button {
  margin-top: 18px !important;
}

.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .advances-package {
  padding-bottom: 16px !important;
}

.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .package-name {
  font-size: 24px !important;
  line-height: 28px !important;
  justify-content: start !important;
}

/* ===== Plan V5 Onboarding Inline ===== */

.form-onboarding-plan-v5 {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 40px;
  gap: 24px;
}

.form-onboarding-plan-v5 .page-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  margin: 0;
}

.form-onboarding-plan-v5 .plan-layout {
  display: flex;
  gap: 24px;
  align-items: stretch;
}

/* Left: Recommended Plan Card */
.form-onboarding-plan-v5 .recommended-plan-card {
  flex: 0 0 300px;
  border: 1px solid #00a47c;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}

.form-onboarding-plan-v5 .recommended-plan-card.recommended-plan-card__enterprise {
  flex: 0 0 400px;
}

.form-onboarding-plan-v5 .recommended-plan-card .header {
  background: linear-gradient(180deg, rgba(40, 162, 182, 0.3) 0%, rgba(76, 184, 121, 0) 100%);
  border-radius: 12px;
}

.form-onboarding-plan-v5 .recommended-plan-card .header .header-content {
  padding: 24px 24px 0px 24px;
}

.form-onboarding-plan-v5 .recommended-badge {
  display: inline-block;
  background: #ffffff;
  color: #005e46;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 8px;
  margin-bottom: 12px;
  width: fit-content;
}

.form-onboarding-plan-v5 .plan-name {
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  margin: 0 0 8px 0;
}

.form-onboarding-plan-v5 .plan-pricing {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.form-onboarding-plan-v5 .price-dollar {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.form-onboarding-plan-v5 .price-amount {
  font-size: 48px;
  font-weight: 700;
  line-height: 1;
}

.form-onboarding-plan-v5 .price-detail {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  color: #637381;
  line-height: 1.4;
  margin-left: 4px;
}

.form-onboarding-plan-v5 .recommended-plan-card .plan-pricing {
  flex-wrap: nowrap;
}

.form-onboarding-plan-v5 .recommended-plan-card .price-detail {
  flex: 1;
  min-width: 0;
}

.form-onboarding-plan-v5 .features-label {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.form-onboarding-plan-v5 .core-features {
  padding: 0 24px 24px 24px;
}

.form-onboarding-plan-v5 .core-features .feature-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.form-onboarding-plan-v5 .core-features .feature-row img {
  flex-shrink: 0;
}

/* Right: Trial Offer Section */
.form-onboarding-plan-v5 .trial-offer-section {
  flex: 1;
  min-width: 0;
  background-color: rgba(255, 255, 255, 1);
  background-image: linear-gradient(180deg, rgba(145, 233, 219, 0.1), rgba(140, 201, 234, 0.01));
  border-radius: 12px;
}

.form-onboarding-plan-v5 .trial-offer-content {
  padding: 20px;
}

.form-onboarding-plan-v5 .trial-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}

.form-onboarding-plan-v5 .trial-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 4px;
}

.form-onboarding-plan-v5 .trial-badge.special-offer {
  background: #fff2d9;
}

.form-onboarding-plan-v5 .trial-badge.special-offer .badge-text {
  background: linear-gradient(90deg, #c830e1, #fe4a25);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.form-onboarding-plan-v5 .trial-badge.why-subscribe {
  background: #fce4ec;
  color: #d81b60;
}

.form-onboarding-plan-v5 .estimated-gmv {
  font-size: 13px;
  color: #202223;
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-onboarding-plan-v5 .info-icon {
  cursor: help;
  font-size: 14px;
  color: #919eab;
}

.form-onboarding-plan-v5 .trial-title {
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin: 0 0 8px 0;
}

.form-onboarding-plan-v5 .trial-description {
  font-size: 14px;
  color: #202223;
  line-height: 1.6;
  margin: 0;
}

.form-onboarding-plan-v5 .pricing-link {
  color: #2c6ecb;
  text-decoration: none;
  font-weight: 500;
}

.form-onboarding-plan-v5 .pricing-link:hover {
  text-decoration: underline;
}

.form-onboarding-plan-v5 .external-icon {
  font-size: 12px;
}

.form-onboarding-plan-v5 .separator {
  border: none;
  border-top: 1px dashed #dfe3e8;
  margin: 16px 0;
}

.form-onboarding-plan-v5 .section-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.form-onboarding-plan-v5 .benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.form-onboarding-plan-v5 .benefit-item img {
  flex-shrink: 0;
  margin-top: 2px;
}

.form-onboarding-plan-v5 .feature-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.form-onboarding-plan-v5 .feature-tag {
  display: inline-block;
  background: #e0f0ff;
  color: #00527c;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 8px;
  font-weight: 500;
  height: 22px;
}

.form-onboarding-plan-v5 .enterprise-upsell .Polaris-Button {
  margin-top: 12px;
}

/* Bottom: Actions */
.form-onboarding-plan-v5 .plan-actions {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 4px;
}

.form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {
  background: #007f5f;
  border-color: #007f5f;
  min-width: 300px;
  max-width: 300px;
}

.gmv-incomplete .form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {
  min-width: 276px;
  max-width: 276px;
}

.form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary:hover {
  background: #006e52;
  border-color: #006e52;
}

.form-onboarding-plan-v5 .skip-link {
  background: none;
  border: none;
  color: #2c6ecb;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
  font-weight: 500;
}

.form-onboarding-plan-v5 .skip-link:hover {
  text-decoration: underline;
}

/* Override parent wrapper constraints */
.plan-v5-page.BC-page_Installation.Onboarding .Polaris-Card {
  max-height: none !important;
}

.plan-v5-page .onboarding--plan-v5 {
  max-height: none !important;
  height: auto !important;
}

.plan-v5-page .wrapper.wrapper--plan-v5 {
  flex-direction: column;
  max-height: none !important;
  height: auto !important;
  overflow: visible;
}

/* ===== GMV Incomplete Sync Layout ===== */

/* Banner */
.form-onboarding-plan-v5 .gmv-incomplete-banner {
  background: #f2f9ff;
  border-radius: 8px;
  padding: 12px 16px;
}

.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-title {
  font-size: 14px;
  font-weight: 500;
  color: #202223;
  display: flex;
  align-items: center;
  gap: 4px;
}

.form-onboarding-plan-v5 .gmv-incomplete-banner .wave-emoji {
  font-size: 28px;
}

.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-subtitle {
  font-size: 13px;
  color: #202223;
  line-height: 1.4;
}

/* Three-column layout */
.form-onboarding-plan-v5 .plan-layout--three-col {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

/* Selectable plan cards */
.form-onboarding-plan-v5 .selectable-plan-card {
  flex: 0 0 276px;
  border: 1px solid #c9cccf;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.form-onboarding-plan-v5 .selectable-plan-card:hover {
  border-color: #8c9196;
}

.form-onboarding-plan-v5 .selectable-plan-card.selected {
  border: 1px solid #00a47c;
  background: linear-gradient(180deg, rgba(40, 162, 182, 0.3) 0%, rgba(76, 184, 121, 0) 100%);
}

.form-onboarding-plan-v5 .selectable-plan-card.popular.selected {
  border: 1px solid #00a47c;
}

.form-onboarding-plan-v5 .selectable-plan-card .header {
  border-radius: 12px;
}

.form-onboarding-plan-v5 .selectable-plan-card .header .header-content {
  padding: 20px 20px 0 20px;
}

.form-onboarding-plan-v5 .selectable-plan-card .plan-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 500;
  padding: 0px 8px;
  border-radius: 8px;
  margin-bottom: 8px;
  width: fit-content;
  height: 20px;
}

.form-onboarding-plan-v5 .selectable-plan-card .badge-starter {
  background: linear-gradient(90deg, rgba(0, 128, 96, 0.5) 0%, #008060 100%);
  color: #ffffff;
}

.form-onboarding-plan-v5 .selectable-plan-card .badge-popular {
  background: #ffffff;
  color: #005e46;
}

.form-onboarding-plan-v5 .selectable-plan-card .plan-name {
  font-size: 22px;
  line-height: 28px;
}

.form-onboarding-plan-v5 .selectable-plan-card .price-amount {
  font-size: 36px;
}

.form-onboarding-plan-v5 .selectable-plan-card .price-dollar {
  font-size: 20px;
}

.form-onboarding-plan-v5 .selectable-plan-card .plan-pricing {
  flex-wrap: nowrap;
}

.form-onboarding-plan-v5 .selectable-plan-card .price-detail {
  flex: 1;
  min-width: 0;
}

.form-onboarding-plan-v5 .selectable-plan-card .core-features {
  padding: 0 20px 20px 20px;
}

.form-onboarding-plan-v5 .selectable-plan-card .features-label {
  font-size: 13px;
}

.form-onboarding-plan-v5 .selectable-plan-card .feature-row {
  font-size: 13px;
}

/* Three-col trial section takes remaining space */
.form-onboarding-plan-v5 .plan-layout--three-col .trial-offer-section {
  flex: 1;
  min-width: 0;
}

/* Responsive */
@media (max-width: 1024px) {
  .form-onboarding-plan-v5 .plan-layout {
    flex-direction: column;
  }

  .form-onboarding-plan-v5 .recommended-plan-card {
    flex: none;
    width: 100%;
  }

  .form-onboarding-plan-v5 .trial-offer-section {
    flex: none;
  }

  .form-onboarding-plan-v5 .plan-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {
    min-width: unset;
  }

  .form-onboarding-plan-v5 .skip-link {
    text-align: center;
  }

  .form-onboarding-plan-v5 .plan-layout--three-col {
    flex-direction: column;
  }

  .form-onboarding-plan-v5 .selectable-plan-card {
    flex: none;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .form-onboarding-plan-v5 {
    padding: 24px 20px;
  }

  .form-onboarding-plan-v5 .page-title {
    font-size: 22px;
    line-height: 28px;
  }

  .form-onboarding-plan-v5 .trial-title {
    font-size: 20px;
    line-height: 28px;
  }

  .form-onboarding-plan-v5 .trial-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/onboarding-plan.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;EAKE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2FAA2F;EAC3F,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,YAAY;EACZ,wCAAwC;EACxC,8FAA8F;EAC9F,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,2CAA2C;;AAE3C,WAAW;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2FAA2F;AAC7F;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,OAAO;EACP,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content {\n  padding: 32px;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar {\n  padding: 14px 20px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button {\n  width: 50px;\n  max-height: 28px;\n  min-height: unset;\n  padding: 10px 6px;\n  border-radius: 8px;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar > div {\n  width: 100%;\n  text-align: center;\n  font-weight: 600;\n  font-size: 22px;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-Button .Polaris-Button__Content {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.BC-Onboarding-Plan-Modal .Polaris-FullscreenBar .Polaris-FullscreenBar__BackAction {\n  display: none;\n}\n\n.BC-Onboarding-Plan-Modal h1 {\n  font-weight: 700;\n  font-size: 28px;\n  text-align: center;\n  margin-bottom: 8px;\n  line-height: 36px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .subtitle {\n  text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3 {\n  max-width: 1172px;\n  margin: auto;\n  margin-top: 24px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .permonth {\n  font-size: 12px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .BC-Page__SubscriptionV3.V4 .price,\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .BC-Page__SubscriptionV3.V4\n  .price\n  > .price-number {\n  font-size: 36px !important;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .compare-action {\n  background-color: #f6f6f7;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button {\n  background-color: transparent;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button__Text {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare\n  .Polaris-Button\n  .Polaris-Icon {\n  margin: 0;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .compare-action\n  .btn-compare.btn-compare--expand\n  .Polaris-Icon {\n  transform: rotate(180deg);\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head {\n  margin-bottom: 48px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-table {\n  width: 100%;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head h1 {\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 36px;\n  margin-bottom: 8px;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .package-comparison-head p {\n  text-align: center;\n}\n\n.BC-Onboarding-Plan-Modal\n  .BC-Onboarding-Plan-Modal__Content\n  .column-package--success\n  .Polaris-Button {\n  background: #008060;\n  border-color: #008060;\n  color: #ffffff;\n}\n\n.BC-Onboarding-Plan-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {\n  overflow: auto;\n  max-height: 500px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top {\n  position: fixed;\n  bottom: 80px;\n  right: 28px;\n  z-index: 99;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #007f5f;\n  cursor: pointer;\n  transition: 0.3s all cubic-bezier(0.075, 0.82, 0.165, 1);\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon {\n  width: 18px;\n  height: 18px;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top .Polaris-Icon .Polaris-Icon__Svg {\n  fill: #007f5f;\n}\n\n.BC-Onboarding-Plan-Modal .btn-to-top:hover {\n  background-color: #fff;\n}\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content {\n  padding: 24px;\n}\n\n.BC-Onboarding-PlanV5-Modal h1 {\n  margin-bottom: 12px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .Polaris-Card {\n  max-width: 936px;\n  margin: auto;\n  margin-top: 24px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-SubscriptionV5_ExplorePackages .packages {\n  margin-top: unset !important;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Page__Package-ComparisonV5 {\n  max-width: 1172px;\n  margin: auto;\n  height: auto;\n  margin-top: 60px;\n}\n\n.BC-Onboarding-PlanV5-Modal .BC-Onboarding-Plan-Modal__Content .collapse-table {\n  max-height: unset;\n}\n\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .info {\n  padding: 31px 20px 16px !important;\n}\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .price {\n  line-height: 40px !important;\n  font-size: 26px !important;\n  justify-content: start !important;\n  margin-top: 11px !important;\n}\n\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .price-number {\n  line-height: 48px !important;\n  font-size: 38px !important;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .price .onboarding-month-text p {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.BC-SubscriptionV5_ExplorePackages .package-card .price .onboarding-month-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: start;\n  margin-left: 8px;\n}\n\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .Polaris-Button {\n  margin-top: 18px !important;\n}\n\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .advances-package {\n  padding-bottom: 16px !important;\n}\n\n.BC-Onboarding-Plan-Modal__Content .package-card-onboarding .package-name {\n  font-size: 24px !important;\n  line-height: 28px !important;\n  justify-content: start !important;\n}\n\n/* ===== Plan V5 Onboarding Inline ===== */\n\n.form-onboarding-plan-v5 {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 32px 40px;\n  gap: 24px;\n}\n\n.form-onboarding-plan-v5 .page-title {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 36px;\n  margin: 0;\n}\n\n.form-onboarding-plan-v5 .plan-layout {\n  display: flex;\n  gap: 24px;\n  align-items: stretch;\n}\n\n/* Left: Recommended Plan Card */\n.form-onboarding-plan-v5 .recommended-plan-card {\n  flex: 0 0 300px;\n  border: 1px solid #00a47c;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-onboarding-plan-v5 .recommended-plan-card.recommended-plan-card__enterprise {\n  flex: 0 0 400px;\n}\n\n.form-onboarding-plan-v5 .recommended-plan-card .header {\n  background: linear-gradient(180deg, rgba(40, 162, 182, 0.3) 0%, rgba(76, 184, 121, 0) 100%);\n  border-radius: 12px;\n}\n\n.form-onboarding-plan-v5 .recommended-plan-card .header .header-content {\n  padding: 24px 24px 0px 24px;\n}\n\n.form-onboarding-plan-v5 .recommended-badge {\n  display: inline-block;\n  background: #ffffff;\n  color: #005e46;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 2px 8px;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  width: fit-content;\n}\n\n.form-onboarding-plan-v5 .plan-name {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 36px;\n  margin: 0 0 8px 0;\n}\n\n.form-onboarding-plan-v5 .plan-pricing {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.form-onboarding-plan-v5 .price-dollar {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.form-onboarding-plan-v5 .price-amount {\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.form-onboarding-plan-v5 .price-detail {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  color: #637381;\n  line-height: 1.4;\n  margin-left: 4px;\n}\n\n.form-onboarding-plan-v5 .recommended-plan-card .plan-pricing {\n  flex-wrap: nowrap;\n}\n\n.form-onboarding-plan-v5 .recommended-plan-card .price-detail {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-onboarding-plan-v5 .features-label {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.form-onboarding-plan-v5 .core-features {\n  padding: 0 24px 24px 24px;\n}\n\n.form-onboarding-plan-v5 .core-features .feature-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.form-onboarding-plan-v5 .core-features .feature-row img {\n  flex-shrink: 0;\n}\n\n/* Right: Trial Offer Section */\n.form-onboarding-plan-v5 .trial-offer-section {\n  flex: 1;\n  min-width: 0;\n  background-color: rgba(255, 255, 255, 1);\n  background-image: linear-gradient(180deg, rgba(145, 233, 219, 0.1), rgba(140, 201, 234, 0.01));\n  border-radius: 12px;\n}\n\n.form-onboarding-plan-v5 .trial-offer-content {\n  padding: 20px;\n}\n\n.form-onboarding-plan-v5 .trial-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.form-onboarding-plan-v5 .trial-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 18px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.form-onboarding-plan-v5 .trial-badge.special-offer {\n  background: #fff2d9;\n}\n\n.form-onboarding-plan-v5 .trial-badge.special-offer .badge-text {\n  background: linear-gradient(90deg, #c830e1, #fe4a25);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.form-onboarding-plan-v5 .trial-badge.why-subscribe {\n  background: #fce4ec;\n  color: #d81b60;\n}\n\n.form-onboarding-plan-v5 .estimated-gmv {\n  font-size: 13px;\n  color: #202223;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.form-onboarding-plan-v5 .info-icon {\n  cursor: help;\n  font-size: 14px;\n  color: #919eab;\n}\n\n.form-onboarding-plan-v5 .trial-title {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32px;\n  margin: 0 0 8px 0;\n}\n\n.form-onboarding-plan-v5 .trial-description {\n  font-size: 14px;\n  color: #202223;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.form-onboarding-plan-v5 .pricing-link {\n  color: #2c6ecb;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.form-onboarding-plan-v5 .pricing-link:hover {\n  text-decoration: underline;\n}\n\n.form-onboarding-plan-v5 .external-icon {\n  font-size: 12px;\n}\n\n.form-onboarding-plan-v5 .separator {\n  border: none;\n  border-top: 1px dashed #dfe3e8;\n  margin: 16px 0;\n}\n\n.form-onboarding-plan-v5 .section-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.form-onboarding-plan-v5 .benefit-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.form-onboarding-plan-v5 .benefit-item img {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.form-onboarding-plan-v5 .feature-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.form-onboarding-plan-v5 .feature-tag {\n  display: inline-block;\n  background: #e0f0ff;\n  color: #00527c;\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-weight: 500;\n  height: 22px;\n}\n\n.form-onboarding-plan-v5 .enterprise-upsell .Polaris-Button {\n  margin-top: 12px;\n}\n\n/* Bottom: Actions */\n.form-onboarding-plan-v5 .plan-actions {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 4px;\n}\n\n.form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {\n  background: #007f5f;\n  border-color: #007f5f;\n  min-width: 300px;\n  max-width: 300px;\n}\n\n.gmv-incomplete .form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {\n  min-width: 276px;\n  max-width: 276px;\n}\n\n.form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary:hover {\n  background: #006e52;\n  border-color: #006e52;\n}\n\n.form-onboarding-plan-v5 .skip-link {\n  background: none;\n  border: none;\n  color: #2c6ecb;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n  font-weight: 500;\n}\n\n.form-onboarding-plan-v5 .skip-link:hover {\n  text-decoration: underline;\n}\n\n/* Override parent wrapper constraints */\n.plan-v5-page.BC-page_Installation.Onboarding .Polaris-Card {\n  max-height: none !important;\n}\n\n.plan-v5-page .onboarding--plan-v5 {\n  max-height: none !important;\n  height: auto !important;\n}\n\n.plan-v5-page .wrapper.wrapper--plan-v5 {\n  flex-direction: column;\n  max-height: none !important;\n  height: auto !important;\n  overflow: visible;\n}\n\n/* ===== GMV Incomplete Sync Layout ===== */\n\n/* Banner */\n.form-onboarding-plan-v5 .gmv-incomplete-banner {\n  background: #f2f9ff;\n  border-radius: 8px;\n  padding: 12px 16px;\n}\n\n.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n\n.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #202223;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.form-onboarding-plan-v5 .gmv-incomplete-banner .wave-emoji {\n  font-size: 28px;\n}\n\n.form-onboarding-plan-v5 .gmv-incomplete-banner .banner-subtitle {\n  font-size: 13px;\n  color: #202223;\n  line-height: 1.4;\n}\n\n/* Three-column layout */\n.form-onboarding-plan-v5 .plan-layout--three-col {\n  display: flex;\n  gap: 16px;\n  align-items: stretch;\n}\n\n/* Selectable plan cards */\n.form-onboarding-plan-v5 .selectable-plan-card {\n  flex: 0 0 276px;\n  border: 1px solid #c9cccf;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card:hover {\n  border-color: #8c9196;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card.selected {\n  border: 1px solid #00a47c;\n  background: linear-gradient(180deg, rgba(40, 162, 182, 0.3) 0%, rgba(76, 184, 121, 0) 100%);\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card.popular.selected {\n  border: 1px solid #00a47c;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .header {\n  border-radius: 12px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .header .header-content {\n  padding: 20px 20px 0 20px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .plan-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 0px 8px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  width: fit-content;\n  height: 20px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .badge-starter {\n  background: linear-gradient(90deg, rgba(0, 128, 96, 0.5) 0%, #008060 100%);\n  color: #ffffff;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .badge-popular {\n  background: #ffffff;\n  color: #005e46;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .plan-name {\n  font-size: 22px;\n  line-height: 28px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .price-amount {\n  font-size: 36px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .price-dollar {\n  font-size: 20px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .plan-pricing {\n  flex-wrap: nowrap;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .price-detail {\n  flex: 1;\n  min-width: 0;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .core-features {\n  padding: 0 20px 20px 20px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .features-label {\n  font-size: 13px;\n}\n\n.form-onboarding-plan-v5 .selectable-plan-card .feature-row {\n  font-size: 13px;\n}\n\n/* Three-col trial section takes remaining space */\n.form-onboarding-plan-v5 .plan-layout--three-col .trial-offer-section {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .form-onboarding-plan-v5 .plan-layout {\n    flex-direction: column;\n  }\n\n  .form-onboarding-plan-v5 .recommended-plan-card {\n    flex: none;\n    width: 100%;\n  }\n\n  .form-onboarding-plan-v5 .trial-offer-section {\n    flex: none;\n  }\n\n  .form-onboarding-plan-v5 .plan-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .form-onboarding-plan-v5 .plan-actions .Polaris-Button--primary {\n    min-width: unset;\n  }\n\n  .form-onboarding-plan-v5 .skip-link {\n    text-align: center;\n  }\n\n  .form-onboarding-plan-v5 .plan-layout--three-col {\n    flex-direction: column;\n  }\n\n  .form-onboarding-plan-v5 .selectable-plan-card {\n    flex: none;\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-onboarding-plan-v5 {\n    padding: 24px 20px;\n  }\n\n  .form-onboarding-plan-v5 .page-title {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  .form-onboarding-plan-v5 .trial-title {\n    font-size: 20px;\n    line-height: 28px;\n  }\n\n  .form-onboarding-plan-v5 .trial-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
